import { useEffect, useRef } from "react";

import { PREFETCHABLE_ROUTES, useNavPrefetch } from "../../api/useNavPrefetch";

/**
 * Renders nothing. Once mounted inside the authenticated shell, it warms the
 * primary nav destinations' data during the browser's first idle window, so
 * clicking a sidebar link lands on already-cached data instead of waiting on a
 * fetch. Runs once per session mount; hover prefetch (Sidebar) covers the rest.
 */
export function NavPrefetcher() {
  const prefetch = useNavPrefetch();
  // Hold the latest callback in a ref so the warm effect can run exactly once
  // without re-firing when `prefetch`'s identity changes (global filters).
  const prefetchRef = useRef(prefetch);
  prefetchRef.current = prefetch;

  useEffect(() => {
    const run = () => {
      for (const route of PREFETCHABLE_ROUTES) {
        prefetchRef.current(route);
      }
    };

    if (typeof window.requestIdleCallback === "function") {
      const id = window.requestIdleCallback(run, { timeout: 2_000 });
      return () => {
        window.cancelIdleCallback?.(id);
      };
    }
    const timer = window.setTimeout(run, 800);
    return () => {
      window.clearTimeout(timer);
    };
  }, []);

  return null;
}
